import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { SelectOptionsContainer, SelectWrapper, TypeaheadSelect } from 'ui/selects';
import { StyledWrapper } from 'ui/inputs/InputStyles';
import { InputText } from 'ui/inputs';
import { pxToRem } from 'utils/convert';

export const StyledInputSelect = styled(TypeaheadSelect)`
  input {
    height: ${pxToRem(30)};
    border-radius: ${spacing.quarter};
  }

  ${StyledWrapper} {
    padding: 0 ${spacing.half};
    border-width: 0;
  }
`;

export const StyledInput = styled(InputText)`
  height: ${pxToRem(30)};
  border-radius: ${spacing.quarter};
  padding: 0 ${spacing.half};
  box-shadow: none;
  & input {
    width: 100%;
  }
`;

export const StyledSelectWrapper = styled(SelectWrapper)`
  box-shadow: none;
`;

export const EllipsizedContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledSelectOptionsContainer = styled(SelectOptionsContainer)`
  min-width: ${pxToRem(300)};  
  width: 120%;
  max-width: ${pxToRem(672)};
`;

export const ExpandedSelectOptionsContainer = styled(SelectOptionsContainer)`
  width: ${pxToRem(672)}
`;
